import React from 'react'
import { styled } from '@mui/material/styles'

const PREFIX = 'Logo'

const classes = {
  logo: `${PREFIX}-logo`
}

const Img = styled('img')(() => ({
  [`&.${classes.logo}`]: {
    maxWidth: 152
  }
}))

type LogoPropTypes = {
  src: string
}

const Logo: React.FC<LogoPropTypes> = ({ src }) => {
  if (!src) {
    return null
  }

  return <Img className={classes.logo} src={src} alt="logo" />
}

export default Logo
